import firebase from 'firebase'

const state = {
    todasEntradas: [],
    principal: [],
    recientes: [],
}

const actions = {
    listarEntradas({ commit }) {
        let todasEntradas = []
        return new Promise((resolve, reject) => {
            firebase.firestore().collection('entradas').orderBy("id", "desc").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    let entradas = doc.data()
                    entradas.id = doc.id
                    todasEntradas.push(entradas)
                });
                commit('guardarEntradas', todasEntradas)
                resolve('lista entradas ok')
                reject('error')
            });
        });
    },
    listarPrincipal({ commit }) {
        let principal = []
        return new Promise((resolve, reject) => {
            firebase.firestore().collection('entradas').orderBy("id", "desc").limit(1).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    let entradas = doc.data()
                    entradas.id = doc.id
                    principal.push(entradas)
                });
                commit('guardarPrincipal', principal)
                resolve('lista entradas ok')
                reject('error')
            });
        });
    },
    recientes({ commit }) {
        let recientes = []
        return new Promise((resolve, reject) => {
            firebase.firestore().collection('entradas').orderBy("id", "desc").limit(4).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    let rec = doc.data()
                    rec.id = doc.id
                    recientes.push(rec)
                });
                commit('guardarRecientes', recientes)
                resolve('lista entradas ok')
                reject('error')
            });
        });
    }
}

const mutations = {
    guardarEntradas(state, todasEntradas) {
        state.todasEntradas = todasEntradas
    },
    guardarPrincipal(state, principal) {
        state.principal = principal
    },
    guardarRecientes(state, recientes) {
        state.recientes = recientes
    },
}

const getters = {
    verEntradas(state) {
        return state.todasEntradas
    },
    verPrincipal(state) {
        return state.principal
    },
    verRecientes(state) {
        return state.recientes
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}